import React, { useState, useEffect } from "react"
import * as countdownStyles from "../../styles/landing_pages/Countdown.module.css"

const Countdown = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date()

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        })
      }
    }

    // Calculate immediately
    calculateTimeLeft()

    // Update every second
    const timer = setInterval(calculateTimeLeft, 1000)

    // Cleanup interval on component unmount
    return () => clearInterval(timer)
  }, [targetDate])

  return (
    <div className={`row ${countdownStyles.countdownContainer}`}>
      <div className={`col ${countdownStyles.countdownWrapper}`}>
        <div className={`row ${countdownStyles.countdownDays}`}>
          <div className="countdown-item">
            <span className="countdown-value">{timeLeft.days}</span>
          </div>
        </div>
        <div className={`row ${countdownStyles.countdownInfo}`}>
          <div className={`col ${countdownStyles.countdownInfoItem}`}>
            <div className="countdown-information">
              <span className="countdown-label">Days to Go!</span>
            </div>
          </div>
        </div>
        <div className={`row ${countdownStyles.countdownTimer}`}>
          <div className={`col ${countdownStyles.countdownTimerItem}`}>
            <div className="countdown-item">
              <span className="countdown-value">{timeLeft.hours}</span>
              <span className="countdown-label"> Hours </span>
            </div>
            <div className="countdown-item">
              <span className="countdown-value">{timeLeft.minutes}</span>
              <span className="countdown-label"> Minutes </span>
            </div>
            <div className="countdown-item">
              <span className="countdown-value">{timeLeft.seconds}</span>
              <span className="countdown-label"> Seconds</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Countdown
